<div class="p-2 sm:p-3 rounded-base h-full flex flex-col gap-3 overflow-hidden">
    <!-- Header -->
    <div class="flex justify-between sm:justify-end items-center flex-shrink-0 gap-2">
        <h2 class="font-bold text-lg sm:text-xl block sm:hidden">Milestones</h2>
        <app-button variant="filled" label="Add Milestone" severity="primary" icon="pi pi-plus"
            (clicked)="showAddMilestoneDialog = true;" class="w-auto" />
    </div>

    <!-- List -->
    <div
        class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3 sm:gap-x-8 sm:gap-y-4 overflow-y-auto flex-1 content-start">
        @for(ms of milestones;track ms){
        <div class="flex justify-between gap-1 sm:gap-2 items-center min-w-0">
            <input type="text" [(ngModel)]="ms.name"
                class="flex-1 min-w-0 p-1.5 sm:p-2 border rounded-base text-sm sm:text-base truncate"
                [disabled]="true" />

            <div class="flex items-center gap-1 flex-shrink-0">
                <!-- Edit -->
                <app-button variant="outlined" severity="contrast" icon="pi pi-pencil"
                    (clicked)="openEditMilestoneDialog(ms)" />

                <!-- Delete (only non-standard) -->
                <app-button variant="outlined" severity="danger" icon="pi pi-trash"
                    (clicked)="openDeleteMilestoneDialog(ms)" />
            </div>
        </div>
        }
    </div>
</div>

<!-- Add / Edit Milestone Dialog -->
<app-dialog [(visible)]="showAddMilestoneDialog"
    [title]="editingMilestone ? 'Edit Milestone' : 'Add Milestone'"
    (closed)="closeMilestoneDialog()" class="max-w-[500px]" [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        <div class="flex flex-col gap-4 p-4">
            <input id="milestoneName" placeholder="Enter Milestone Name" type="text"
                [(ngModel)]="milestoneData.name" class="w-full p-1.5 border rounded-base" />
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex flex-col sm:flex-row justify-end gap-2">
            <app-button variant="outlined" label="Cancel" severity="contrast" icon="pi pi-times"
                (clicked)="closeMilestoneDialog()" class="w-full sm:w-auto" />
            <app-button variant="filled" severity="primary" label="Save" icon="pi pi-save"
                (clicked)="saveMilestone()" [disabled]="!hasChanges" class="w-full sm:w-auto" />
        </div>
    </ng-template>
</app-dialog>

@if(showDeleteDialog){
    <app-delete-confirmation [(visible)]="showDeleteDialog" headerText="Delete Milestone"
        bodyText="Are you sure you want to delete this milestone?" confirmButtonText="Delete" width="90vw"
        [style]="{'max-width': '500px'}" (onConfirm)="deleteMilestone()" (onCancel)="closeDeleteMilestoneDialog()">
    </app-delete-confirmation>
}
